import type { DSBest } from 'shared-definitions/types'
import type { ApiBest } from 'data-source/types.wp'
import type { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { clearbuyLinkMapper } from 'data-source/mappers/clearbuyLink'
import { ncProductMSRPMapper } from 'data-source/mappers/ncProductMSRPMapper'

export function bestMapper(input: ApiBest, opts: PLinkMapperOpts): DSBest | [] {
  const image = imageMapper(input.image, opts)
  if (!image) {
    return []
  }

  const reviewLink = input.review_url ? clearbuyLinkMapper(input.review_url, opts) : null
  return {
    title: input.title,
    manufacturer: input.manufacturer ?? null,
    score: input.rating !== 0 ? input.rating : null,
    positives: input.positives && input.positives.length ? input.positives : null,
    negatives: input.negatives && input.negatives.length ? input.negatives : null,
    bottomLine: input.bottom_line ? input.bottom_line : null,
    reviewButton: reviewLink
      ? {
          label: input.review_url_label ?? 'Read full review...',
          pLink: reviewLink,
        }
      : null,
    sponsored: input.is_promoted,
    badge: imageMapper(input.badge, opts),
    image,
    shopLink: input.shop_url ? clearbuyLinkMapper(input.shop_url, opts) : null,
    isFeatured: input.is_featured,
    isPromoted: input.is_promoted,
    msrp: ncProductMSRPMapper(input),
    headLabel: input.icon_title
      ? {
          title: input.icon_title,
          icon: input.icon ?? null,
        }
      : null,
  }
}
